<template>
  <div class="flex flex-col h-screen bg-gray-50 font-sans">
    <HomeTopBar :expanded="expanded" @toggle="toggle"/>
    <div class="flex flex-1 overflow-hidden">
      <aside
        class="shrink-0 h-full transition-all duration-300"
        :class="expanded ? 'w-64' : 'w-16'">
        <SideMenu :full="expanded"/>
      </aside>
      <main id="main-content" class="flex-1 min-w-0 p-4 overflow-y-auto">
        <div class="flex flex-col bg-white rounded p-2">
          <RouterView/>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import SideMenu from "@/domains/home/SideMenu.vue";
import HomeTopBar from "@/domains/home/HomeTopBar.vue";

const SIDEBAR_STORAGE_KEY = "sidebar_expanded";

const expanded = ref<boolean>(localStorage.getItem(SIDEBAR_STORAGE_KEY) !== "false");

const toggle = () => {
  expanded.value = !expanded.value;
  localStorage.setItem(SIDEBAR_STORAGE_KEY, String(expanded.value));
};
</script>
